import { createTheme } from '@mui/material/styles';
 const theme = createTheme({
   typography: {
    fontFamily: 'Poppins, sans-serif',
   }
});

export default theme;